import {
  Ban,
  Bot,
  Clock,
  LucideIcon,
  Menu as MenuIcon,
  MessageSquare,
  PhoneForwarded,
  PhoneOff,
  Repeat,
  User,
  UserCheck,
  Users,
  Voicemail,
  Volume2,
} from "lucide-react";
import { CallFlowActionType } from "@/model/interface/CallFlowActionType";
import { NODE_LABELS } from "@/util/callFlowNodes";

export interface ActionTypeOption {
  actionType: CallFlowActionType;
  label: string;
  icon: LucideIcon;
  pickable: boolean;
  isPro: boolean;
}

function option(
  actionType: CallFlowActionType,
  icon: LucideIcon,
  { isPro = false, pickable = true }: { isPro?: boolean; pickable?: boolean } = {},
): ActionTypeOption {
  return { actionType, label: NODE_LABELS[actionType], icon, pickable, isPro };
}

export const ACTION_TYPE_OPTIONS: ActionTypeOption[] = [
  option(CallFlowActionType.SAY_MESSAGE, MessageSquare),
  option(CallFlowActionType.CALL_USER, User),
  option(CallFlowActionType.CALL_NUMBER, PhoneForwarded),
  option(CallFlowActionType.VOICEMAIL, Voicemail),
  option(CallFlowActionType.HANGUP, PhoneOff),
  option(CallFlowActionType.DNC_OPT_OUT, Ban),
  option(CallFlowActionType.MENU, MenuIcon, { isPro: true }),
  option(CallFlowActionType.RING_GROUP, Users, { isPro: true }),
  option(CallFlowActionType.ROUND_ROBIN, Repeat, { isPro: true }),
  option(CallFlowActionType.ROUTE_TO_OWNER, UserCheck, { isPro: true }),
  option(CallFlowActionType.BUSINESS_HOURS, Clock, { isPro: true }),
  option(CallFlowActionType.AI_AGENT, Bot, { isPro: true }),
  option(CallFlowActionType.PLAY_AUDIO, Volume2, { pickable: false }),
];

export const PICKABLE_ACTION_TYPES = ACTION_TYPE_OPTIONS.filter((candidate) => candidate.pickable);
const STANDARD_ACTION_TYPES = PICKABLE_ACTION_TYPES.filter((candidate) => !candidate.isPro);
const PRO_ACTION_TYPES = PICKABLE_ACTION_TYPES.filter((candidate) => candidate.isPro);
const PICKER_ROW_COUNT = Math.max(STANDARD_ACTION_TYPES.length, PRO_ACTION_TYPES.length);

export interface PickerRow {
  standard?: ActionTypeOption;
  pro?: ActionTypeOption;
}

export const PICKER_ROWS: PickerRow[] = Array.from(Array(PICKER_ROW_COUNT).keys()).map((rowIndex) => ({
  standard: STANDARD_ACTION_TYPES[rowIndex],
  pro: PRO_ACTION_TYPES[rowIndex],
}));

export function isProActionType(actionType: unknown): boolean {
  return typeof actionType === "string" && PRO_ACTION_TYPES.some((candidate) => candidate.actionType === actionType);
}

export function actionTypeOption(actionType: CallFlowActionType): ActionTypeOption | undefined {
  return ACTION_TYPE_OPTIONS.find((candidate) => candidate.actionType === actionType);
}
